import { RefiBackButton } from './back-button.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../icon-sprites.js';
import '../../query-assigned-elements.js';
import '../../directive.js';
import '../../unsafe-html.js';

defineRefiElement('refi-common-back-button', RefiBackButton);
